/** @format */

import React, { useEffect } from 'react';
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { Routes, Route } from 'react-router-dom';
import './App.css';
import { Methods } from './components/Methods';
import { WalletMethod } from './components/paymentMethods/Wallet';
import { BankTransferMethod } from './components/paymentMethods/Transfer';
import { KudaMethod } from './components/paymentMethods/Kuda';
import { MonoMethod } from './components/paymentMethods/Mono';
import { UssdMethod } from './components/paymentMethods/Ussd';
import { Card } from './components/paymentMethods/Card';
import { AppShell } from './components/AppShell';
import { MpesaMethod } from './components/paymentMethods/Mpesa';
import { CellulantMethod } from './components/paymentMethods/Cellulant';
import { MobileMoneyMethod } from './components/paymentMethods/MobileMoney';
import { StitchMethod } from './components/paymentMethods/Stitch';
import { BusinessWallet } from './components/paymentMethods/BusinessWallet';

function App() {

    const flagEnabled = useFeatureFlagEnabled('enable_inspect')    

    useEffect(() => {
        const disableRightClick = (e: { preventDefault: () => any; }) => e.preventDefault();
        const disableInspect = (e: { ctrlKey: any; shiftKey: any; key: string; preventDefault: () => void; }) => {
          if (e.ctrlKey && e.shiftKey && e.key === 'I') e.preventDefault();
        };

        if (flagEnabled) {
          document.addEventListener('contextmenu', disableRightClick);
          document.addEventListener('keydown', disableInspect);
        }

        return () => {
          document.removeEventListener('contextmenu', disableRightClick);
          document.removeEventListener('keydown', disableInspect);
        };
      }, [flagEnabled]);
  

	return (
		<div
			className="App"
			id="App"
		>
			<AppShell>
				<Routes>
					<Route
						path="/"
						element={<Methods />}
					/>
					<Route
						path="/methods"
						element={<Methods />}
					/>
					<Route
						path="wallet"
						element={<WalletMethod />}
					/>
					<Route
						path="transfer"
						element={<BankTransferMethod />}
					/>
					<Route
						path="kuda"
						element={<KudaMethod />}
					/>
					<Route
						path="mono"
						element={<MonoMethod />}
					/>
					<Route
						path="card"
						element={<Card />}
					/>
					<Route
						path="ussd"
						element={<UssdMethod />}
					/>
					<Route
						path="mpesa"
						element={<MpesaMethod />}
					/>
					<Route
						path="cellulant"
						element={<CellulantMethod />}
					/>
					<Route
						path="mobileeast"
						element={<MobileMoneyMethod />}
					/>
					<Route
						path="stitch"
						element={<StitchMethod />}
					/>
					<Route
						path="business"
						element={<BusinessWallet />}
					/>

				</Routes>
			</AppShell>
		</div>
	);
}

export default App;
